import { useEffect, useState } from 'react';

import { useAuth } from 'components/context/AuthContext';
import { useCurrentUser } from 'hooks/user/useCurrentUser';
import { isAllowedToApply } from 'components/profile/ApplicationStatusCard/utils';

import { Form } from './components/Form';
import { BecomeSpeakerSuccessNotification } from './components/SuccessNotification';
import { BecomeSpeakerAppliedNotification } from './components/AppliedNotification';
import { BecomeSpeakerUnauthorizedNotification } from './components/UnauthorizedNotification';

import { TFormStatus } from './BecomeSpeaker.types';

import { UserType } from 'graphql/types';

import css from './BecomeSpeaker.module.scss';

export const BecomeSpeaker = () => {
  const { isAuthorized } = useAuth();
  const user = useCurrentUser().data?.me as UserType;

  const [status, setStatus] = useState<TFormStatus>(null);

  useEffect(() => {
    if (isAuthorized !== null) {
      if (isAuthorized && user) {
        if (isAllowedToApply(user?.speakerRequests || null, isAuthorized)) {
          setStatus('initial');
        } else if (status === 'initial') {
          setStatus('success');
        } else {
          setStatus('applied');
        }
      } else {
        setStatus('unauthorized');
      }
    }
  }, [isAuthorized, user]);

  switch (status) {
    case 'initial':
      return <Form setStatus={setStatus} user={user} />;
    case 'success':
      return <BecomeSpeakerSuccessNotification />;
    case 'applied':
      return (
        <BecomeSpeakerAppliedNotification
          status={user?.speakerRequests?.status ?? null}
        />
      );
    case 'unauthorized':
      return <BecomeSpeakerUnauthorizedNotification />;
    default:
      // TODO: сделать локальный или глобальный (основанный на AuthProvider) лоадер
      return <div className={css.empty} />;
  }
};

export default BecomeSpeaker;
